import { z } from 'zod';
export const conversionSettingsSchema = z.object({
    metaEnabled: z.boolean(),
    metaDatasetId: z.string().nullable(),
    metaPageId: z.string().nullable(),
    metaTokenLast4: z.string().nullable(),
    metaTestCode: z.string().nullable(),
    google: z.object({
        available: z.boolean(), // a plataforma configurou a API do Google Ads
        connected: z.boolean(), // a clínica conectou a conta Google
        accountEmail: z.string().nullable(),
        enabled: z.boolean(),
        customerId: z.string().nullable(),
        loginCustomerId: z.string().nullable(),
        actions: z.object({ created: z.string().nullable(), evaluation_scheduled: z.string().nullable(), won: z.string().nullable() }),
    }),
    updatedAt: z.string().nullable(),
});
const numericId = (label) => z.string().trim().regex(/^\d{6,25}$/, `${label}: só números`);
export const saveConversionSettingsSchema = z.object({
    metaEnabled: z.boolean(),
    metaDatasetId: numericId('ID do conjunto de dados').nullable(),
    metaPageId: numericId('ID da página').nullable(),
    /** vazio = mantém o token salvo */
    metaToken: z.string().trim().max(600).optional().transform((v) => v || undefined),
    metaTestCode: z.string().trim().max(40).nullable().transform((v) => v || null),
});
export const conversionEventSchema = z.object({
    id: z.uuid(), leadId: z.uuid(), contactName: z.string(), platform: z.enum(['meta', 'google']), eventName: z.string(), status: z.enum(['pending', 'sent', 'failed']),
    valueCents: z.number().int().nullable(), occurredAt: z.string(), sentAt: z.string().nullable(), lastError: z.string().nullable(),
    attempts: z.number().int(), test: z.boolean(),
});
/** Etapa do funil → evento da Meta (mensagens da empresa). */
export const META_EVENTS = { created: 'LeadSubmitted', evaluation_scheduled: 'Schedule', won: 'Purchase' };
export const META_EVENT_LABELS = { LeadSubmitted: 'Lead (conversa iniciada)', Schedule: 'Avaliação agendada', Purchase: 'Venda (orçamento aceito)' };
const customerId = z.string().trim().transform((v) => v.replace(/\D/g, '')).pipe(z.string().regex(/^\d{10}$/, 'ID do cliente: 10 dígitos (ex.: 123-456-7890)'));
const actionRef = z.string().regex(/^customers\/\d{10}\/conversionActions\/\d+$/).nullable();
export const saveGoogleConversionsSchema = z.object({
    enabled: z.boolean(),
    customerId: customerId.nullable(),
    loginCustomerId: customerId.nullable().optional().transform((v) => v ?? null),
    actions: z.object({ created: actionRef, evaluation_scheduled: actionRef, won: actionRef }),
});
export const googleConversionActionSchema = z.object({ resourceName: z.string(), name: z.string(), category: z.string().nullable() });
/** Console: API do Google Ads (vale para todas as clínicas). */
export const googleAdsAppSchema = z.object({
    developerToken: z.string().trim().min(10).max(100).optional().transform((v) => v || undefined),
    clientId: z.string().trim().regex(/\.apps\.googleusercontent\.com$/, 'ID do cliente OAuth termina em .apps.googleusercontent.com'),
    clientSecret: z.string().trim().max(200).optional().transform((v) => v || undefined),
});
//# sourceMappingURL=conversions.js.map